import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useFabletics from '../../hooks/useFabletics';
import FableticsMemberBanner from './FableticsMemberBanner';
import FableticsUpsellBanner from './FableticsUpsellBanner';

const FableticsBanner = ({ surface = PowerFunnelSurfaces.HOME }) => {
    const { enabled, isUpsellAudience } = useFabletics();
    if (!enabled) {
        return null;
    }
    const BannerComponent = isUpsellAudience ? FableticsUpsellBanner : FableticsMemberBanner;
    return <BannerComponent surface={surface} />;
};

FableticsBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
};

FableticsBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
};

export default FableticsBanner;
